import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'bg-slider',
    template: `<input
        type="range"
        icon="chevron-left"
        [attr.id]="id"
        [attr.min]="min"
        [attr.max]="max"
        [ngModel]="value"
        (input)="onChange($event)" />`,
    imports: [CommonModule, FormsModule],
})
export class SliderComponent {
    @Input() min: number;
    @Input() max: number;
    @Input() value: number;
    @Input() id: number;
    @Output() onSelected: EventEmitter<any> = new EventEmitter<any>();
    constructor() {}

    onChange(el: any) {
        this.onSelected.emit({
            selectedValue: +el.target.value,
            id: this.id,
        });
    }
}
